import type { RouteObject } from 'react-router-dom';

import MainLayout from '@/app/layouts/MainLayout';
import { AuthGuard, BusinessGuard } from '@/app/router/guards';
import { lazyRoute } from '@/app/router/helpers';
import { ROUTES } from '@/shared/constants/app/routes.constant.ts';

/**
 * `/business/*` — 기업 콘솔 **진입 스텁**.
 *
 * 화면 자체는 console-web 으로 이관됐다. 여기 남는 이유는 둘이다:
 *  1. 기존 링크·북마크·메일 본문의 `/business/...` 를 대응하는 콘솔 경로로 넘긴다.
 *  2. 콘솔이 미인증 진입 시 `?from=/business/console?next=...` 로 복귀 지점을 잡는다.
 *
 * AuthGuard → BusinessGuard 를 그대로 통과시키므로, 콘솔에 갈 자격이 없는 사용자는
 * 콘솔로 튕기기 전에 web 안에서(마이페이지 안내) 걸러진다.
 */
export const businessRoutes: RouteObject = {
  path: ROUTES.BUSINESS,
  Component: MainLayout,
  children: [
    {
      element: <AuthGuard />,
      children: [
        {
          element: <BusinessGuard />,
          children: [
            {
              // 하위 경로 전부(`/business`, `/business/licenses`, `/business/console` …)
              path: '*',
              ...lazyRoute(() => import('@/pages/business/ConsoleEntryPage')),
            },
            {
              index: true,
              ...lazyRoute(() => import('@/pages/business/ConsoleEntryPage')),
            },
          ],
        },
      ],
    },
  ],
};
